import React from 'react';
import { Users, Target, ShieldCheck } from 'lucide-react';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-1">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-4" data-id="element-4">
            About AMK Solutions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-5">
            We are a premier customer support agency dedicated to helping
            businesses manage their customer communications with efficiency,
            professionalism, and a human touch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6">
          {[{
          icon: Users,
          title: 'Expert Team',
          description: 'Our agents undergo rigorous training to understand your brand voice and product details inside out.'
        }, {
          icon: Target,
          title: 'Result Driven',
          description: 'We focus on metrics that matter: First Response Time, CSAT scores, and resolution efficiency.'
        }, {
          icon: ShieldCheck,
          title: 'Reliable Partner',
          description: 'We act as an extension of your team, providing seamless support that your customers can trust.'
        }].map((item, index) => <div key={index} className="bg-slate-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow duration-300 border border-slate-100" data-id="element-7">
              <div className="mx-auto h-14 w-14 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mb-6" data-id="element-8">
                <item.icon className="h-7 w-7" data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-10">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-11">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}